module.exports = __webpack_public_path__ + "img/works_jeju_y_btm_off.82ecfaec.jpg";